import { useEffect } from 'react'

import { useEsri } from '../hooks'

import {
  HORRY_ELECTRIC_OUTAGES_LAYER,
  HORRY_STREETS_MAP,
  PROXY_URL,
} from '../constants'

const esriReqs = ['esri/layers/MapImageLayer', 'esri/core/urlUtils']

const PowerOutagesLayer = ({ map, view }) => {
  const [ready, { MapImageLayer, urlUtils }] = useEsri(esriReqs)

  useEffect(() => {
    if (ready && map) {
      urlUtils.addProxyRule({
        urlPrefix: 'portal.horryelectric.com',
        proxyUrl: PROXY_URL,
      })

      const horryElectricOutagesLayer = new MapImageLayer({
        url: HORRY_ELECTRIC_OUTAGES_LAYER,
      })
      const roadsLayer = new MapImageLayer({
        url: HORRY_STREETS_MAP,
      })

      map.add(horryElectricOutagesLayer)
      map.add(roadsLayer)
    }
  }, [ready, MapImageLayer, map, urlUtils])

  return null
}

export default PowerOutagesLayer
